import React, { useRef } from 'react';
import { IApplicationState } from '../../store';
import BrazeEvents from '../../helpers/braze';
import useExitDetection from './exit-detection';
import { useSelector } from 'react-redux';

const ExitIntentComponent = () => {
    const lastExitIntentTimeRef = useRef(0);
    const timeoutDuration = 5000;
    const selectedLanguage = useSelector((state: IApplicationState) => state.intl.selectedLanguage);
    const brazeUserLang = selectedLanguage.momentLocale.length > 2 ? selectedLanguage.momentLocale.slice(0, 2) : selectedLanguage.momentLocale;

    const handleExitIntent = (_eventType: any) => {
        const now = Date.now();
        const url = window.location.href;

        if (now - lastExitIntentTimeRef.current >= timeoutDuration) {
            BrazeEvents.LogExitIntent(url, brazeUserLang);

            lastExitIntentTimeRef.current = now;
        }
    };

    useExitDetection(handleExitIntent);

    return <></>;
};

export default ExitIntentComponent;
